export const handleDownloadFile = (url: string) => {
  const link = document.createElement("a");
  link.href = url; // Set the URL to the pre-signed download URL
  link.download = ""; // Optional: Set a filename if needed
  link.target = "_blank"; // Open in a new tab or start download directly
  document.body.appendChild(link); // Append the link to the document
  link.click(); // Programmatically trigger the click event
  document.body.removeChild(link); // Clean up by removing the link
};
